module.exports = __webpack_public_path__ + "static/media/ic_archive_sidebar.c16fffda.svg";